import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

export const DrawerContext = createContext();

export const DrawerProvider = ({ children }) => {
  const [drawers, setDrawers] = useState([]);

  const openDrawer = useCallback((component, props, onClose) => {
    setDrawers((prevDrawers) => [
      ...prevDrawers,
      { component, props, onClose },
    ]);
  }, []);

  const updateDrawerProps = useCallback((index, nextProps) => {
    setDrawers((prevDrawers) =>
      prevDrawers.map((drawer, drawerIndex) => {
        if (drawerIndex !== index || !drawer) return drawer;

        const resolvedProps =
          typeof nextProps === "function"
            ? nextProps(drawer.props || {})
            : nextProps;

        return {
          ...drawer,
          props: {
            ...(drawer.props || {}),
            ...(resolvedProps || {}),
          },
        };
      }),
    );
  }, []);

  // const handleDrawerExited = (index) => {
  //   console.log("handleDrawerExited")
  //   setDrawers((prevDrawers) => prevDrawers.filter((_, i) => i !== index));
  // };

  // Problems with race conditions...
  const handleDrawerExited = useCallback((index) => {
    setDrawers((prev) => {
      // Set the specified index to null
      const updatedDrawers = [...prev];
      updatedDrawers[index] = null;

      // Find the highest non-null index
      const highestNonNullIndex = updatedDrawers
        .map((drawer, i) => (drawer !== null ? i : -1))
        .reduce((max, i) => Math.max(max, i), -1);

      // If the index being closed is the highest, trim nulls from the end
      if (index >= highestNonNullIndex) {
        return updatedDrawers.slice(0, highestNonNullIndex + 1);
      }

      // Otherwise, return the array with the null preserved
      return updatedDrawers;
    });
  }, []);

  const closeAllDrawers = useCallback(() => {
    setDrawers([]);
  }, []);

  const contextValue = useMemo(
    () => ({
      drawers,
      openDrawer,
      updateDrawerProps,
      handleDrawerExited,
      closeAllDrawers,
    }),
    [drawers, openDrawer, updateDrawerProps, handleDrawerExited, closeAllDrawers]
  );

  return (
    <DrawerContext.Provider value={contextValue}>{children}</DrawerContext.Provider>
  );
};

export const useDrawer = () => useContext(DrawerContext);
